import VendorLogo from "@/components/VendorLogo";
import { getStorageLogoUrl, getStorageShortLabel } from "@/pages/import/DatalakesPage/storage";

const VendorBadge = ({ storage }: { storage: string }) => (
  <span className="inline-flex items-center gap-x-2">
    <VendorLogo logo_url={getStorageLogoUrl(storage)} />
    {getStorageShortLabel(storage)}
  </span>
);

export default VendorBadge;
